import React, { PureComponent } from 'react';
import { RadioField } from 'src/components/basic';
import { lang, scssVariables as variables } from 'src/helpers';
import { CARD_LOGOS } from 'src/helpers/cardTypes';
import AlertManager from 'src/components/alert/AlertManager';
import SVGIcon, { BASE_ICONS } from '../svg';
import { remCss } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

class StripePaymentMethod extends PureComponent {
  deleteCard = (e) => {
    e && e.stopPropagation();
    let { onDelete, data } = this.props;
    AlertManager.popup(AlertManager.TYPES.WARN, {
      width: 400,
      close: false,
      title: LANG_CONST.notice.delete,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: (actions) => {
          actions.setLoading(true);
          onDelete(data, (err, res, success) => {
            actions.setLoading(false);
            if (success) {
              actions.hide();
            } else {
              alert(`error: ${err}`);
            }
          });
        }
      }
    });
  };

  onClick = (e) => {
    e.stopPropagation();
    this.props.onClick && this.props.onClick(this.props.data);
  };

  render() {
    let {
      onClick = null,
      onDelete = null,
      data: paymentData,
      small = false,
      short = false,
      logoWidth
    } = this.props;
    const { id, card, active } = paymentData;

    let cardLogo = CARD_LOGOS[card?.brand || card?.type] || CARD_LOGOS.blank;

    if (!logoWidth && small) logoWidth = 50;

    return (
      <div
        data-testid={active ? 'active-payment-card' : 'payment-card'}
        data-payment-card-id={id}
        className={[
          'mc-payment-card',
          active && 'mc-active',
          short && 'mc-payment-card-short',
          small && 'mc-payment-card-small'
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={onClick && this.onClick}
        style={{ cursor: onClick ? 'pointer' : 'default' }}
      >
        {onClick && <RadioField checked={active} template={'2'} onClick={this.onClick} />}
        {cardLogo && (
          <img
            src={cardLogo}
            style={{
              ...(logoWidth ? { width: remCss(logoWidth) } : { width: remCss(80) })
            }}
          />
        )}
        {card?.last4 && (
          <div
            className={['mc-grow', 'mc-value-420', 'mc-text-truncate'].join(' ')}
            style={{ whiteSpace: 'nowrap' }}
          >
            {'**** **** ****'} {card?.last4}
          </div>
        )}
        {card?.email && (
          <div
            className={['mc-grow', 'mc-value-420', 'mc-text-truncate'].join(' ')}
            style={{ whiteSpace: 'nowrap' }}
          >
            {card?.email}
          </div>
        )}
        {id === 'new' && (
          <div
            className={['mc-grow', 'mc-value-520', 'mc-text-truncate'].join(' ')}
            style={{ whiteSpace: 'nowrap', padding: remCss(15) }}
          >
            {lang.t('New')}
          </div>
        )}
        {!short && card?.exp_month && (
          <div className={'mc-flex-10-col'} style={{ minWidth: 0, maxWidth: remCss(125) }}>
            <div className={'mc-label-416 mc-text-truncate'}>{lang.t('VALID THRU')}</div>
            <div className={['mc-value-420', 'mc-text-truncate'].join(' ')}>
              {card?.exp_month}/{card?.exp_year}
            </div>
          </div>
        )}
        {onDelete && (
          <button className={'mc-no-style-btn'} type={'button'} onClick={this.deleteCard}>
            <SVGIcon
              iconname={BASE_ICONS.DELETE}
              light
              radius
              width={44}
              padding={10}
              fill={variables['colors-mc-danger']}
            />
          </button>
        )}
      </div>
    );
  }
}

export default StripePaymentMethod;
